import i18next from "i18next"
import { EOrderStatusType } from "../../Enum/EOrderStatus"
import { OrderEntity } from "./OrderEntity"

export interface OrderStatusBadge {
  label: string

  className: string
}

const DEFAULT_PAYMENT_TIMEOUT_MINUTES = 10

export const getOrderFlowStatusBadges = (
  order: OrderEntity,
  paymentTimeoutMinutes: number = DEFAULT_PAYMENT_TIMEOUT_MINUTES,
): OrderStatusBadge[] => {
  if (order.eOrderStatusType === EOrderStatusType.WaitingOnlinePayment) {
    const createdAt = new Date(order.createdAtUtc || order.date)
    const expirationDate = new Date(createdAt)

    expirationDate.setMinutes(expirationDate.getMinutes() + paymentTimeoutMinutes)

    const isExpired = Date.now() >= expirationDate.getTime()

    return [
      {
        label: i18next.t("order:status_flow_negotiation"),
        className: "bg-violet-100 ring-1 ring-violet-300 text-violet-700",
      },
      {
        label: isExpired
          ? i18next.t("order:status_flow_expired_cleanup")
          : i18next.t("order:status_flow_waiting_payment"),
        className: isExpired
          ? "bg-red-100 ring-1 ring-red-300 text-red-700"
          : "bg-amber-100 ring-1 ring-amber-300 text-amber-700",
      },
    ]
  }

  switch (order.eOrderStatusType) {
    case EOrderStatusType.Pending:
      return [
        {
          label: i18next.t("order:status_flow_pending"),
          className: "bg-slate-100 ring-1 ring-slate-300 text-slate-700",
        },
      ]
    case EOrderStatusType.Preparing:
      return [
        {
          label: i18next.t("order:status_flow_preparing"),
          className: "bg-orange-100 ring-1 ring-orange-300 text-orange-700",
        },
      ]
    case EOrderStatusType.PreparingFinished:
      return [
        {
          label: i18next.t("order:status_flow_preparing_finished"),
          className: "bg-green-100 ring-1 ring-green-300 text-green-700",
        },
      ]
    case EOrderStatusType.InDelivery:
      return [
        {
          label: i18next.t("order:status_flow_in_delivery"),
          className: "bg-indigo-100 ring-1 ring-indigo-300 text-indigo-700",
        },
      ]
    case EOrderStatusType.Delivered:
      return [
        {
          label: i18next.t("order:status_flow_delivered"),
          className: "bg-emerald-100 ring-1 ring-emerald-300 text-emerald-700",
        },
      ]
    default:
      return [
        {
          label: i18next.t("order:status_flow_pending"),
          className: "bg-slate-100 ring-1 ring-slate-300 text-slate-700",
        },
      ]
  }
}
